module.exports = __webpack_public_path__ + "static/media/HP_card_turtle_crossing.f2b4db65.jpg";